module.exports = __webpack_public_path__ + "img/partner_5.298733a6.png";